import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class EssaiDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"ESSAI"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "ESSAI",
            buteur: event.detail?.buteur,
          };
    }

    get buteur() {
        return this.detail.buteur;
    }
    set buteur(value) {
        this.detail.buteur = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "buteur"].includes(key)){
            let commentaire = "Essai"

            const buteurPlayer = getPlayer(this.buteur, match)
            const team = getTeam(this.team, match)

            if(this.buteur){
                if(this.buteur === 'edp'){
                    commentaire += ' de pénalité'
                }else if(buteurPlayer){
                    commentaire += ' de '+ buteurPlayer.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            this.text = commentaire
        }
    }
}